module.exports = __webpack_public_path__ + "static/media/logo-넷앤드.523ff25b.png";